import { Card, Spin, Tabs } from "antd";
import { MyHeader } from "Components/MyHeader/MyHeader";
import { CalendarWrapper } from "./components/CalendarWrapper/CalendarWrapper";
import { SettingsWrapper } from "./components/SettingsWrapper/SettingsWrapper";
import { TableWrapper } from "./components/TableWrapper/TableWrapper";
import MyBtnConfirm from "Components/MyBtnConfirm/MyBtnConfirm";
import { ScheduleOutlined } from "@ant-design/icons";
import { defaultSettings } from "css/defaultAntStyles";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router";
import { useEffect, useState } from "react";
import {
  getProjectInfoThunk,
  getTableMaterialsForProjectThunk,
  getWorksTableProjectThunk,
  selectProject,
  setFinishProjectThunk,
} from "AppStore/Slices/ProjectSlice/ProjectSlice";
import { MyText } from "Components/MyText/MyText";
import dayjs from "dayjs";
import {
  getBlanksThunk,
  selectBlank,
} from "AppStore/Slices/BlankSlice/BlankSlice";
import { checkRoleAccess } from "Helpers/checkRoleAccess";
import { ROLE } from "Helpers/roles/roles";
import { selectUser } from "AppStore/Slices/UserSlice/UserSlice";
import { MaterialsWrapper } from "./components/MaterialsWrapper/MaterialsWrapper";

export const MyProjectPage = () => {
  const [monthNumber, setMonthNumber] = useState(dayjs().month() + 1);
  const [activeKey, setActiveKey] = useState("calendar");
  const { projectId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    if (projectId) {
      dispatch(getProjectInfoThunk(projectId));
    } else {
      navigate("/");
    }
  }, [projectId]);

  const {
    title,
    projectStatus,
    isLoading,
    isUserCreatorOfThisProject,
    userRolesForThisProject,
  } = useSelector(selectProject);
  const { roles } = useSelector(selectUser);
  const { isLoading: isLoadingBlanks } = useSelector(selectBlank);

  const items = [
    {
      key: "calendar",
      label: "Календар",
      children: (
        <CalendarWrapper
          disabled={projectStatus.status === "завершений проект"}
          projectId={projectId}
          monthNumber={monthNumber}
          setMonthNumber={setMonthNumber}
        />
      ),
    },
    {
      key: "table",
      label: "Роботи",
      children: (
        <TableWrapper
          projectTitle={title}
          disabled={projectStatus.status === "завершений проект"}
          monthNumber={monthNumber}
          setMonthNumber={setMonthNumber}
        />
      ),
    },
    {
      key: "tablematerials",
      label: "Матеріали",
      children: (
        <MaterialsWrapper
          projectTitle={title}
          disabled={projectStatus.status === "завершений проект"}
        />
      ),
    },
    checkRoleAccess(
      [ROLE.ENGINEER, ROLE.MANAGER],
      userRolesForThisProject,
      isUserCreatorOfThisProject,
      roles,
    ) && {
      key: "settings",
      label: "Налаштування проекту",
      children: (
        <SettingsWrapper
          disabled={
            projectStatus.status === "завершений проект" ||
            !isUserCreatorOfThisProject
          }
        />
      ),
    },
  ].filter(Boolean);

  const finishProject = () => {
    dispatch(setFinishProjectThunk()).then(() => {
      navigate("/");
    });
  };

  useEffect(() => {
    if (activeKey === "table") {
      dispatch(getWorksTableProjectThunk());
    }
    if (activeKey === "calendar" && monthNumber) {
      dispatch(getBlanksThunk({ monthNumber, projectId }));
    }
    if (activeKey === "tablematerials" && monthNumber) {
      dispatch(getTableMaterialsForProjectThunk());
    }
  }, [activeKey, monthNumber, projectId]);

  return (
    <div>
      <MyHeader
        mainTitle={title}
        secondaryText="Управління обліком: календар, детальна таблиця та налаштування проекту"
        btnHeader={
          isUserCreatorOfThisProject
            ? projectStatus.status !== "завершений проект"
              ? () => (
                  <MyBtnConfirm
                    onConfirm={finishProject}
                    textBtn={"Завершити проект"}
                    mainTitle="Перевести проект в завершений статус?"
                    icon={
                      <ScheduleOutlined
                        style={{
                          color: defaultSettings.colorPrimary,
                          fontSize: "30px",
                        }}
                      />
                    }
                  />
                )
              : () => {
                  return <MyText text={"Проект завершено"} />;
                }
            : null
        }
      />

      <Spin spinning={isLoading || isLoadingBlanks}>
        <Card style={{ borderRadius: 16 }}>
          <Tabs
            defaultActiveKey="calendar"
            items={items}
            centered
            onChange={(key) => {
              setActiveKey(key);
            }}
          />
        </Card>
      </Spin>
    </div>
  );
};
